import {graphNode, lazyDefinition} from "@cm/graph-v3"
import {
    registerTemplateGraphNode,
    templateListNodeDefinition,
    TemplateListNode,
    ExportNode,
    numberLikeNode,
    materialLike,
    imageLike,
    stringLikeNode,
    transformLikeNode,
    templateLike,
    templateOwningContainerMarker,
} from "@cm/template-nodes"
import type {
    NumberLikeNode,
    MaterialLikeNode,
    ImageLikeNode,
    StringLikeNode,
    TransformLikeNode,
    TemplateLikeNode,
    TemplateOwningContainer,
} from "@cm/template-nodes"
import {MattressNode} from "#mattress/nodes/mattress-node"
import {z} from "zod/v4-mini"

// Any node a mattress component graph can hold.
// MattressNode / ExportNode are abstract bases: `instanceof` captures all subclasses without a marker.
export type MattressComponentGraphNode =
    | MattressNode
    | NumberLikeNode
    | MaterialLikeNode
    | ExportNode<unknown>
    | TemplateLikeNode
    | ImageLikeNode
    | StringLikeNode
    | TransformLikeNode

const mattressComponentGraphNode: z.ZodMiniType<MattressComponentGraphNode, MattressComponentGraphNode> = z.union([
    graphNode(MattressNode),
    numberLikeNode,
    materialLike,
    graphNode(ExportNode),
    templateLike,
    imageLike,
    stringLikeNode,
    transformLikeNode,
])

export const isMattressComponentGraphNode = (x: unknown): x is MattressComponentGraphNode => mattressComponentGraphNode.safeParse(x).success

const mattressNodesDefinition = lazyDefinition(() => templateListNodeDefinition("MattressNodes", mattressComponentGraphNode))

@registerTemplateGraphNode
export class MattressNodes extends TemplateListNode<MattressComponentGraphNode> implements TemplateOwningContainer {
    get [templateOwningContainerMarker]() {
        return true as const
    }
    public override get definition() {
        return mattressNodesDefinition()
    }
}
